exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.vx-timeline{\n  margin-left:1.5rem;\n  padding-left:40px;\n  border-left:2px solid #e5e8eb\n}\n.theme-dark .vx-timeline{\n  border-color:#414561\n}\n.vx-timeline li{\n  position:relative;\n  margin-bottom:20px\n}\n.vx-timeline li .timeline-icon{\n  position:absolute;\n  top:0;\n  left:-4.3rem;\n  border-radius:50%;\n  padding:.75rem;\n  padding-bottom:.4rem\n}\n.vx-timeline li .activity-desc{\n  font-size:.9rem\n}\n.vx-timeline li .activity-e-time{\n  font-size:.8rem\n}", ""]);

// exports
